import { useLocalStorage } from '@/hooks'

import { DEFAULT_LINK_STYLE, LinkStyle, parseLinkStyle } from './linked-columns.constants'

export const LINK_STYLE_STORAGE_KEY = 'linked-columns-link-style'

// Note: one stored value for every page that uses LinkedColumns, so the choice carries over
export const useLinkStyle = (): [LinkStyle, (style: LinkStyle) => void] => {
  const [stored, setStored] = useLocalStorage<LinkStyle>(LINK_STYLE_STORAGE_KEY, DEFAULT_LINK_STYLE)

  return [parseLinkStyle(stored), setStored]
}
